import { render, staticRenderFns } from "./ordersListDetailTable.vue?vue&type=template&id=9edc98ae&scoped=true"
import script from "./ordersListDetailTable.vue?vue&type=script&lang=js"
export * from "./ordersListDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ordersListDetailTable.vue?vue&type=style&index=0&id=9edc98ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edc98ae",
  null
  
)

export default component.exports